import { uuid } from "uuidv4";
import { trackEvent } from "./serverSide";
import { CinemaType, LoyaltyLevelType } from "../../types/entities";
import { addCinemaFieldsToEventData, dataLayerPush } from "../analytics";

export const trackLoopSignUpLanding = (cinema: CinemaType) => {
    const eventData = {
        content_ids: [`loop_${cinema.id}`],
        content_type: 'product',
        content_name: `Loyalty Sign Up - ${cinema.name}`,
        currency: 'MXN',
        value: 0,
        content_category: 'Loyalty Program'
    };

    addCinemaFieldsToEventData(eventData, cinema);

    trackEvent(
        'ViewContent',
        uuid(),
        eventData
    );

    dataLayerPush({
        event: 'qualify_lead',
        currency: 'MXN',
        value: 0,
        method: 'loop'
    });
};

export const trackLoopSignUpLevelSelect = (cinema: CinemaType, level: LoyaltyLevelType) => {
    const metaEventData = {
        content_name: `Sign Up - ${level.name}`,
    };

    addLevelFieldsToMetaEventData(metaEventData, level);
    addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'AddToCart',
        uuid(),
        metaEventData
    );

    const googleEventData = { event: 'add_to_cart' };

    addLevelFieldsToGoogleEventData(googleEventData, level);
    dataLayerPush(googleEventData);
};

export const trackLoopSignUpComplete = (cinema: CinemaType, level: LoyaltyLevelType, result: any) => {
    const metaEventData = {
        content_name: `Sign Up Confirmation - ${level.name}`,
    };

    addLevelFieldsToMetaEventData(metaEventData, level);
    addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'Purchase',
        uuid(),
        metaEventData
    );

    dataLayerPush({
        event: 'generate_lead',
        currency: 'MXN',
        value: 0,
        method: 'loop'
    });
    
    const googleEventData = {
        event: 'purchase',
        transaction_id: `loop_${result.transaction_id}`,
    };

    addLevelFieldsToGoogleEventData(googleEventData, level);
    dataLayerPush(googleEventData);
};

function addLevelFieldsToMetaEventData(eventData: { [key: string]: any }, level: LoyaltyLevelType) {
    eventData.content_ids = [`loop_${level.id}`];
    eventData.content_type = 'product';
    eventData.currency = 'MXN';
    eventData.value = level.price;
    eventData.content_category = `Loyalty Program > ${level.name}`;
}

function addLevelFieldsToGoogleEventData(eventData: { [key: string]: any }, level: LoyaltyLevelType) {
    eventData.currency = 'MXN';
    eventData.value = level.price;
    eventData.items = [
        {
            item_id: `loop_${level.id}`,
            item_name: level.name,
            quantity: 1,
            price: level.price
        }
    ]
}